<template>
	<div class="wrapper-template">
		<v-radio-group v-model="answerSelected">
			<div class="answer" v-for="answer in answers" :key="answer.id">
				<label
					:for="`answer-${questionId}-${answer.id}`"
					:class="[ answerSelected === answer.id ? 'answer-selected' : 'answer-text' ]">
					{{answer.name}}
				</label>
				<v-radio
					:id="`answer-${questionId}-${answer.id}`"
					:value="answer.id"
					@change="selectAnswer">
				</v-radio>
			</div>
		</v-radio-group>
	</div>
</template>
<script>

function selectAnswer(id) {
	this.$emit('selected-icon', id);
	if (!this.answerSelected) {
		this.$store.commit('UPDATE_POLL_PROGRESS', 1);
	}
	this.answerSelected = id;
}

function data() {
	return {
		answerSelected: 0,
	};
}

export default {
	name: 'radio-button-template',
	data,
	methods: {
		selectAnswer,
	},
	props: {
		answers: {
			default: () => [],
			type: Array,
		},
		questionId: Number,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/polls/radio-button-template.vue